<script lang="ts">
import postalIconSaints from '@/assets/images/postal-icon-saints.svg'
import postalIcon from '@/assets/images/postal-icon.svg'
import { useRouteMeta } from '@/plugins/useRouteMeta'
import { defineComponent } from 'vue'

/**
 * A card to display a plan.
 *
 */
export default defineComponent({
  setup() {
    return {
      routeMeta: useRouteMeta().meta,
      postalIcon,
      postalIconSaints,
    }
  },
  computed: {
    postalIconSrc(): string {
      return this.$theme?.name?.toLowerCase() === 'saints'
        ? this.postalIconSaints
        : this.postalIcon
    },
  },
})
</script>

<template>
  <article class="plan-card" tabindex="0">
    <div class="plan-header">
      <div class="flex items-center gap-3 font-bold">
        <AppIcon :icon="Icons.CloverOutlined" class="hidden @lg/main:inline" />
        Free Postal Entry
      </div>
    </div>

    <div class="plan-content">
      <div class="flex flex-col items-center justify-end flex-1">
        <img :src="postalIconSrc" alt="Postal Icon" class="mx-auto" />

        <div class="my-3 text-xl font-bold italic">
          {{ $t('section.plans.card.free.heading') }}
        </div>

        <p class="my-3">
          You can enter for free online, just click the button below.
        </p>

        <AppButton
          v-if="routeMeta.featuredCampaign"
          :route="{
            name: 'campaign',
            params: {
              campaignCode: routeMeta.featuredCampaign.code,
            },
          }"
          class="w-full font-bold capitalize !h-11 button-primary mt-3"
          :title="$t('section.plans.card.free.excerpt.via_online')"
          :icon="Icons.ArrowRight"
        >
          {{ $t('section.plans.card.free.excerpt.via_online') }}
        </AppButton>
      </div>

      <div class="flex flex-col place-content-center gap-6 flex-1">
        <div class="line-through-sides font-bold w-full">
          {{ $t('section.plans.card.free.excerpt.via_post') }}
        </div>

        <p>
          Click
          <RouterLink :to="{ name: 'full-terms-and-conditions' }" class="link"
            >here</RouterLink
          >
          to read more about the postal entry route
        </p>
      </div>
    </div>
  </article>
</template>

<style lang="scss" scoped>
.plan-card {
  @apply flex flex-grow flex-col rounded-xl shadow-[0_10px_15px_-4px_#6664] bg-pure-white mb-4;

  .plan-header {
    @apply flex px-4 py-3 font-bold text-xl justify-between items-center rounded-t-xl gap-1 bg-[#E2EAED];
  }

  .plan-content {
    @apply @md/main:px-6 pt-6 p-2 pb-10 flex flex-col justify-center items-center border-2 border-gray-200 rounded-b-xl flex-grow;

    p {
      @apply text-center;
    }
  }

  .icon {
    @apply size-5 @md/main:size-6 flex-shrink-0 !important;
  }
}
</style>
